<button mat-icon-button color="primary"
    (click)="this.clicked($event)">
  <mat-icon>fullscreen{{ expanded ? '_exit' : '' }}</mat-icon>
</button>
